<template>
  <div class="infor evInfor" :class="getBg(this.headerStatus)">
    <div class="header-dialog">
      <div class="top-name" :class="getTopBg(this.headerStatus)">
        <div class="name">{{ headerName }}</div>
        <div @pointerdown="clickClose" class="imgbg"></div>
      </div>
      <div class="middle-name">
        <div class="left-text">{{ headerEqpName }}</div>
        <div class="right-status" :class="getStatus(this.headerStatus)">
          {{ statusMap[this.headerStatus] }}
        </div>
      </div>
      <div class="bot-name">
        <div class="text">序列号</div>
        <div class="num">{{ headerSerialNumber || "---" }}</div>
      </div>
      <div class="line"></div>
    </div>
    <pannel-data :pannelDatas="headerData" :isShowMinor="isShowMinor">
      <slot></slot>
    </pannel-data>
  </div>
</template>

<script>
import pannelData from "./components/pannel-data.vue";
import bus from "@/components/three-scene/Bus.js";
export default {
  name: "pannel-box",
  components: { pannelData },
  props: {
    headerName: String,
    headerData: Object,
    isShowMinor: Boolean,
  },
  data() {
    return {
      isshow: false,
      statusMap: ["停用", "正常", "故障", "异常"],
    };
  },
  computed: {
    headerStatus() {
      return this?.headerData?.status;
    },
    headerEqpName() {
      return this?.headerData?.eqpName;
    },
    headerSerialNumber() {
      return this?.headerData?.serialNumber;
    },
  },
  methods: {
    getStatus(val) {
      // val=null;
      if (val != undefined) {
        if (val == 0) {
          return "wait-bg";
        } else if (val == 2 || val == 3) {
          return "warn-bg";
        } else {
          return "normal-bg";
        }
      } else {
        return "";
      }
    },
    getBg(val) {
      //  val=null;
      if (val != undefined) {
        if (val == 0) {
          return "standby-infor";
        } else if (val == 2 || val == 3) {
          return "warn-infor";
        } else {
          return "infor";
        }
      } else {
        return "";
      }
    },
    // getColor(val){
    //   if (val) {
    //     if (val == 0) {
    //       return "white-num";
    //     } else if (val == 2) {
    //       return "warn-color";
    //     } else {
    //       return "num-bue";
    //     }
    //   } else {
    //     return "";
    //   }
    // },
    getTopBg(val) {
      if (val != undefined) {
        if (val == 0) {
          return "top-color2";
        } else if (val == 2 || val == 3) {
          return "top-color1";
        } else {
          return "top-name";
        }
      } else {
        return "";
      }
    },
    // 点击关闭
    clickClose() {
      this.$parent.isShowDialog = false;
      this.$emit("close");
      bus.emit("pdjClickIsshow");
    },
  },
};
</script>

<style lang="scss" scoped>
// .white-num {
//   color: #fff !important;
// }

// .num-bue {
//   color: #2d82ff !important;
// }

// .warn-color {
//   color: #f1802f !important;
// }

.infor::before {
  content: "";
  z-index: -1;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  // backdrop-filter: blur(5px);
  background: inherit;
}

.water-normal-bg {
  background-image: url("../../assets/cut/info-bg-blue.png");
}

.water-wait-bg {
  background-image: url("../../assets/cut/info-bg-wait.png");
}

.water-warn-bg {
  background-image: url("../../assets/cut/info-bg-warn.png");
}

.infor {
  pointer-events: all;
  width: 381px;
  padding-bottom: 20px;
  // min-height: 462px;
  // background-size: cover;
  // background-image: url("../../assets/cut/newdialodbg-bg.png");
  border-image: url("../../assets/cut/backimg-normal.png");

  color: #fff;

  .header-dialog {
    .top-color1 {
      background: rgba(241, 128, 47, 0.4);
    }
    .top-color2 {
      background: rgba(175, 175, 175, 0.4);
    }

    .middle-name {
      margin: 20px auto;
      .left-text {
        width: 251px;
        // height: 23px;
        color: #fff;
      }

      .right-status {
        width: 70px;
        height: 30px;
        margin-left: 26px;
        border-radius: 2px;
        font-size: 14px;
        line-height: 30px;
        color: #ffffff;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .normal-bg {
        background: rgba(45, 130, 255, 0.3);
        border: 2px solid rgba(45, 130, 255, 0.2);
        box-shadow: 0px 0px 4px 2px rgba(45, 130, 255, 0.2),
          inset 0px 0px 8px 2px #2d82ff;
      }

      .warn-bg {
        background: rgba(241, 128, 47, 0.3);
        border: 2px solid rgba(241, 128, 47, 0.2);
        box-shadow: 0px 0px 4px 2px rgba(241, 128, 47, 0.2),
          inset 0px 0px 8px 2px #f1802f;
      }

      .wait-bg {
        background: rgba(255, 255, 255, 0.3);
        border: 2px solid rgba(255, 255, 255, 0.2);
        box-shadow: 0px 0px 4px 2px rgba(255, 255, 255, 0.2),
          inset 0px 0px 8px 2px #ffffff;
      }
    }
    .bot-name {
      margin-top: -10px;
    }
  }
}
.warn-infor {
  border-image: url("../../assets/cut/test.png");
}
.standby-infor {
  border-image: url("../../assets/cut/stand.png");
}
.infor,
.standby-infor,
.warn-infor {
  border-image-slice: 55 166 75 65 fill;
  border-image-width: 20px 50px 20px 20px; // 设置各个区域的图片宽度
  border-image-repeat: repeat; // 图片重复或拉伸模式
  // border-image-outset: 10px 10px 10px 10px; //
}
</style>
